export default __webpack_public_path__ + "media/images/corporate/apartments/first_slide_sm-14f932ffc0a07da46f6c12cc5814bdfd.png";